import axios from "axios";
import { ProbeDataGraphType } from "types/enums";
import { getAPIURL } from "./";
axios.defaults.withCredentials = true;

export const getProbeSummary = async (
  probeIds: Array<number>
): Promise<any> => {
  return await axios
    .post<any>(getAPIURL("Probe/GetProbeSummary"), { probeIds: probeIds })
    .then((response) => {
      return response.data;
    });
};

export const getLatestProbeData = (): Promise<Array<common.Probe>> => {
  return axios
    .get<any>(getAPIURL("Probe/GetLatestProbeAndData"))
    .then((response) => {
      return response.data?.probes;
    });
};

export const getProbeData = async (
  probeId: number,
  probeDataGraphType: ProbeDataGraphType
): Promise<Array<common.ProbeData>> => {
  return await axios
    .get<any>(
      getAPIURL(`ProbeData/GetProbeData/${probeId}/${probeDataGraphType}`)
    )
    .then((response) => {
      return response.data;
    });
};

/**
 * Update probe
 * @param probe The probe to update
 */
export const updateProbe = (
  probe: common.Probe
): Promise<Array<common.Probe>> => {
  const cleanedProbe = { ...probe, probeData: [], image: undefined };
  const image = probe.image;

  let bodyFormData = new FormData();
  bodyFormData.append("file", image);
  bodyFormData.append("probeId", probe.id.toString());

  return axios
    .put(getAPIURL("Probe/UpdateProbe"), cleanedProbe)
    .then(() => {
      axios.post(getAPIURL("Probe/UploadFile"), bodyFormData);
    })
    .then(() => getLatestProbeData())
    .then((response) => {
      return response;
    });
};
